import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PestMapping from "../components/PestMappingList";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      {/* <MasterLayout> */}

        {/* Breadcrumb */}
        <Breadcrumb title="Crop Pest Mapping" />

        {/* UsersListLayer */}
        <PestMapping />

      {/* </MasterLayout> */}

    </>
  );
};

export default UsersListPage; 
